module.exports = __webpack_public_path__ + "img/kkgfdyh.7ebdfb76.png";